<template>
  <div v-if="isAdmin">
    <label>User Permissions</label>
    <div class="form-group">
      <ul class="permissions">
        <li v-for="permission in permissions" :key="permission.label">
          <label :for="permission.label">
            <input
              type="checkbox"
              :id="permission.label"
              v-model="user.access"
              :value="permission.value"
            />
            {{ permission.label }}
          </label>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  props: ["user"],

  data() {
    return {
      permissions: [
        {
          label: "Email Properties",
          value: "email-properties"
        },
        {
          label: "Assets",
          value: "assets"
        },
        // {
        //   label: "Deleted assets",
        //   value: "deleted-assets"
        // },
        {
          label: "Pages",
          value: "pages"
        },
        {
          label: "Navigation",
          value: "navigation"
        },
        {
          label: "Live",
          value: "live"
        },
        {
          label: "Live Active Toggle Switch",
          value: "live-toggle"
        },
        {
          label: "Users",
          value: "users"
        },
        {
          label: "Settings",
          value: "settings"
        },
        // {
        //   label: "Heatmaps",
        //   value: "heatmaps"
        // },
        {
          label: "Push To Production",
          value: "push-production"
        }
      ]
    };
  },

  computed: {
    isAdmin() {
      return this.$store.getters.currentUser.isAdmin;
    }
  }
};
</script>
<style lang="scss" scoped>
.permissions {
  list-style: none;
  padding: 0 16px;

  li {
    label {
      font-size: 14px;
      user-select: none;
    }
  }
}
</style>
